import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42d5aaef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manifold m-url" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_redemption_selection = _resolveComponent("m-redemption-selection")!
  const _component_m_redemption_details = _resolveComponent("m-redemption-details")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.activeEligibleToken)
      ? (_openBlock(), _createBlock(_component_m_redemption_selection, { key: 0 }))
      : (_ctx.state.activeRedemption)
        ? (_openBlock(), _createBlock(_component_m_redemption_details, { key: 1 }))
        : _createCommentVNode("", true)
  ]))
}